import * as sdk from '@cirqll/sdk';
import type { UserModule } from '~/types';

export const install: UserModule = ({ router }) => {
    router.beforeResolve(async (to, from) => {
        if (to.name === '/customer/[id]') {
            const id = +to.params.id;
            if (Number.isNaN(id)) {
                return from;
            }
            try {
                await sdk.queryClient.ensureQueryData(sdk.customer.get(id, { with: ['field_values', 'address', 'media'] }));
            } catch {
                return from;
            }
        }
    });
};
